<template>
  <div class="chat-user-multimedia__block">
    <div class="chat-user-multimedia__navigation">
      <div class="chat-user-multimedia__navigation-list">
        <div
          v-for="(tab, index) in tabs"
          :key="index"
          :class="[{ 'is-active': tab.isActive }]"
          :title="tab.name"
          @click="selectTab(tab)"
          class="chat-user-multimedia__navigation--item"
          role="button">
          <div v-if="tab.hasIcon">
            <component :is="tab.icon"/>
            <a>{{ tab.title }}</a>
          </div>
        </div>
      </div>
    </div>
    <div class="chat-user-multimedia__content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import TypeDocumentIcon from '@/assets/icons/type-document.svg';
import TypeImageIcon from '@/assets/icons/type-image.svg';
import TypeVideoIcon from '@/assets/icons/type-video.svg';

export default {
  components: {
    TypeDocumentIcon,
    TypeImageIcon,
    TypeVideoIcon,
  },
  data() {
    return {
      tabs: [],
    };
  },
  created() {
    this.tabs = this.$children;
  },
  methods: {
    selectTab(selectedTab) {
      this.tabs.forEach((tab) => {
        // eslint-disable-next-line no-param-reassign
        tab.isActive = tab.name === selectedTab.name;
      });
    },
  },
};
</script>
